import { Shield } from "lucide-react";
import { flagUrl } from "@/lib/team-flags";
import { cn } from "@/lib/utils";

interface Props {
  team: string | null | undefined;
  size?: "sm" | "md" | "lg";
  className?: string;
}

const SIZES = {
  sm: { box: "h-5 w-7", img: 40 },
  md: { box: "h-6 w-9", img: 80 },
  lg: { box: "h-8 w-12", img: 160 },
} as const;

/** Country flag for a team, falls back to a neutral shield icon for placeholders. */
export const TeamFlag = ({ team, size = "md", className }: Props) => {
  const url = flagUrl(team, SIZES[size].img as 40 | 80 | 160);
  const cls = cn(
    "inline-flex items-center justify-center overflow-hidden rounded-sm bg-muted shrink-0 ring-1 ring-border/60",
    SIZES[size].box,
    className,
  );
  if (!url) {
    return (
      <span className={cls} aria-hidden>
        <Shield className="h-3.5 w-3.5 text-muted-foreground" />
      </span>
    );
  }
  return (
    <span className={cls}>
      <img src={url} alt="" loading="lazy" className="h-full w-full object-cover" />
    </span>
  );
};
